import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { PRODUCT_VALUE_PATTERN } from './product-value-pattern.js';
export const calEventProductValueEntryInputSchema = z
    .object({
    productId: requiredUuidString('Product is required.', 'Invalid product.').nullish(),
    categoryId: requiredUuidString('Category is required.', 'Invalid category.').nullish(),
    fieldKey: z.string().trim().min(1, 'Field is required.').max(64, 'Invalid field.'),
    value: z
        .string()
        .regex(PRODUCT_VALUE_PATTERN, 'Enter a number of 0 or more with up to 9 decimals.')
        .nullable(),
})
    .refine((entry) => (entry.productId == null) !== (entry.categoryId == null), 'Choose either a product or a category.');
//# sourceMappingURL=cal-event-product-value-entry-input.js.map